// extracted by mini-css-extract-plugin
export default {"financeTab":"screener-tab-finance_financeTab__F1Fwl","preloaderWrapper":"screener-tab-finance_preloaderWrapper__gvO6F","error":"screener-tab-finance_error__NgEH+"};